import * as angular from "angular";
import {IController} from "angular";
import {PriceType} from "../../types/price.type";

export class ProgramDistanceViewCtrl implements IController {

  programId: string;
  priceType: PriceType;

  constructor() {

  }

  $onInit() {

  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('programDistanceView', {
    bindings: {
      programId: '<',
      priceType: '<'
    },
    template: require('./program-distance-view.html').default,
    controller: ProgramDistanceViewCtrl
  });
